import { ListOrdered } from "lucide-react";

export const fmtClock = (s) => {
  const sec = Math.max(0, Math.floor(s || 0));
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const r = sec % 60;
  return h ? `${h}:${m.toString().padStart(2, "0")}:${r.toString().padStart(2, "0")}` : `${m}:${r.toString().padStart(2, "0")}`;
};

/** Clickable chapter markers under a replay. `currentTime` (s) highlights the active one. */
export default function ReplayChapters({ chapters = [], currentTime = 0, onSeek, disabled = false, testPrefix = "chapter", compact = false }) {
  if (!chapters.length) return null;
  const activeIdx = chapters.reduce((acc, c, i) => (currentTime >= c.start ? i : acc), 0);
  return (
    <div className="rounded-2xl border border-border bg-background/60 p-3 sm:p-4" data-testid={`${testPrefix}-list`}>
      <div className="mb-2 flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
        <ListOrdered className="h-3.5 w-3.5" /> Chapters · {chapters.length}
      </div>
      <ol className={compact ? "space-y-0.5" : "grid gap-1 sm:grid-cols-2"}>
        {chapters.map((c, i) => {
          const active = i === activeIdx && currentTime > 0;
          return (
            <li key={`${c.start}-${i}`}>
              <button
                type="button"
                disabled={disabled}
                onClick={() => onSeek?.(c.start)}
                title={c.summary || c.title}
                className={`group flex w-full items-start gap-3 rounded-lg px-2.5 py-2 text-left transition-colors hover:bg-secondary disabled:cursor-default disabled:opacity-60 ${active ? "bg-primary/10" : ""}`}
                data-testid={`${testPrefix}-${i}`}
                data-active={active ? "true" : "false"}
              >
                <span className={`mt-0.5 shrink-0 rounded-md px-1.5 py-0.5 font-mono text-[11px] tabular-nums ${active ? "bg-primary text-primary-foreground" : "bg-secondary text-muted-foreground group-hover:text-foreground"}`}>{fmtClock(c.start)}</span>
                <span className="min-w-0">
                  <span className={`block truncate text-sm font-medium ${active ? "text-primary" : "text-foreground"}`}>{c.title}</span>
                  {!compact && c.summary && <span className="mt-0.5 line-clamp-2 block text-xs text-muted-foreground">{c.summary}</span>}
                </span>
              </button>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
